import { useSelector } from '../redux/store';

export default function useFeaturePermission(featureName) {
    const permissions = useSelector((state) => state.permissions.permissions);
    const level = permissions?.[featureName] || 'hidden';

    return {
        level,
        canView: level === 'view' || level === 'manage',
        canManage: level === 'manage',
        isHidden: level === 'hidden',
        isEnabled: level !== 'hidden',
    };
}
